import React, { Component } from 'react';

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
      };
    }

    // eslint-disable-next-line consistent-return
    async componentDidMount() {
      const alreadyReloaded = JSON.parse(
        window.localStorage.getItem('page-reloaded') || 'false',
      );

      try {
        const { default: component } = await importComponent();

        window.localStorage.setItem('page-reloaded', 'false');

        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          component,
        });
      } catch (error) {
        if (!alreadyReloaded) {
          window.localStorage.setItem('page-reloaded', 'true');
          return window.location.reload();
        }

        throw error;
      }
    }

    render() {
      const LoadedComponent = this.state.component;
      return LoadedComponent ? <LoadedComponent {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}
